export const supportTranslations = {
  // List page
  title: "Support",
  subtitle: "Get help from the Zaviago team and track your requests.",
  newRequest: "New request",
  searchPlaceholder: "Search requests…",
  filterAll: "All",
  filterActive: "Active",
  updatedAgo: "Updated {{time}}",
  newReply: "New reply",
  emptyNoTicketsTitle: "No support requests yet",
  emptyNoTicketsDesc:
    "When you need help, open a request and the Zaviago team will get back to you here.",
  emptyNoMatchTitle: "No requests match this filter",
  emptyNoMatchDesc: "Try a different filter or clear your search.",

  // Floating widget
  widgetGreeting: "How can we help?",
  widgetGreetingSub: "We usually reply in a few minutes.",
  widgetViewAll: "Open full Support",
  widgetLauncher: "Support",
  widgetNewReplyToast: "Support replied to your request",

  // View switcher
  viewList: "List",
  viewBoard: "Board",
  viewCalendar: "Calendar",
  calendarToday: "Today",
  calendarMore: "+{{count}} more",

  // Presence strip
  presenceOnline: "We're online",
  presenceReplyTime: "Typically replies in a few minutes",
  presenceCountOnline: "{{count}} online now",
  presenceAvgReply: "Typically replies in ~{{mins}} min",
  presence247: "Available 24/7",
  presenceSecondsAgo: "active {{sec}}s ago",
  presenceJustNow: "active just now",

  // Status labels
  statusOpen: "Open",
  statusInProgress: "In Progress",
  statusWaiting: "Waiting on you",
  statusResolved: "Resolved",
  statusClosed: "Closed",

  // Priority labels
  priorityLow: "Low",
  priorityMedium: "Medium",
  priorityHigh: "High",
  priorityUrgent: "Urgent",

  // Category labels
  categoryBilling: "Billing",
  categoryTechnical: "Technical",
  categoryBug: "Bug",
  categoryFeatureRequest: "Feature Request",
  categoryOther: "Other",

  // Compose page
  composeTitle: "New support request",
  composeSubtitle: "The Zaviago team will reply and you can track it anytime.",
  cancel: "Cancel",
  sendRequest: "Send request",
  subjectLabel: "Subject",
  subjectPlaceholder: "What do you need help with?",
  detailsLabel: "Details",
  categoryLabel: "Category",
  priorityLabel: "Priority",
  descriptionLabel: "Description",
  descriptionPlaceholder:
    "Describe the issue, what you expected, and drop in screenshots or a screen recording. Use the toolbar to add images or video.",
  descriptionTip:
    "Tip: use the image and video buttons to attach screenshots or a screen recording.",

  // Rich composer toolbar
  toolbarBold: "Bold",
  toolbarItalic: "Italic",
  toolbarUnderline: "Underline",
  toolbarBulletList: "Bulleted list",
  toolbarNumberedList: "Numbered list",
  toolbarInsertImage: "Insert image",
  toolbarInsertVideo: "Insert video",

  // Page context (auto-attached)
  contextTitle: "Reporting from this page",
  contextHint:
    "If the problem is on a different page, go there before sending — we attach the page so we can see exactly what you see.",
  contextReportedFrom: "Reported from",
  entityProduct: "Product",
  entityOrder: "Order",
  entityCustomer: "Customer",
  entityPage: "Current page",

  // Knowledge-base deflection (compose)
  kbTitle: "Articles that might help",

  // CSAT (after resolve)
  csatQuestion: "Did this solve your problem?",
  csatYes: "Yes, thanks",
  csatNo: "Not yet",
  csatThanks: "Thanks for your feedback!",

  // Activity timeline
  timelineResolved: "Marked as resolved",
  timelineReopened: "Reopened",

  // Conversation UX (customer)
  agentTyping: "Support is typing…",
  sending: "Sending…",
  sent: "Sent",
  seen: "Seen by our team",
  sendFailed: "Failed to send",
  retry: "Retry",
  estResponse: "We usually reply within ~{{mins}} min",
  replyToMessage: "Reply",
  replyingTo: "Replying to",
  quickNotFixed: "Still not resolved",
  quickThanks: "Thank you!",
  quickMoreInfo: "I have another question",
  dateToday: "Today",
  dateYesterday: "Yesterday",

  // Detail page
  backToSupport: "Back to Support",
  notFound: "We couldn't find that request.",
  reopen: "Reopen",
  markResolved: "Mark resolved",
  openedAgo: "Opened {{time}}",
  agentName: "Zaviago Support",
  replyPlaceholder: "Write a reply…",
  sendHint: "⌘/Ctrl + Enter to send",
  send: "Send",
};
